import { createFileRoute } from "@tanstack/react-router"
import DesignSystemTextarea from "~/pages/design-system/components/Textarea"

export const Route = createFileRoute("/_auth/internal/design-system/components/textarea")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemTextarea />
}
